import CardDesignerCardElementColorControl from './CardDesignerCardElementColorControl';

export default CardDesignerCardElementColorControl;
